<template>
    <div>
        <b-card>
            <material-analysis
                :tableName="tableName"
                :columnData="columnData"
                :tableHeader="tableHeader"
                :tableHeaderData="tableHeaderData"
                @onLoadTable="onLoadTable"
            >
            </material-analysis>

            <material-analysis-charts-welding
                v-if="showCharts"
                :rowData="rowData"
            >
            </material-analysis-charts-welding>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue';
import MaterialAnalysis from '@/components/pages/project/percent_progress/common/tables/material_analysis.vue';
import MaterialAnalysisChartsWelding from '@/components/pages/project/percent_progress/welding/material_analysis/material_analysis_charts_welding.vue';

export default {
    name: 'material_analysis_welding',
    components: {
        MaterialAnalysis,
        MaterialAnalysisChartsWelding,
    },
    data() {
        return {
            rowData: [],
            showCharts: false,
            tableName: 'progress_welding_material_analysis',
            columnData: [
                {
                    label: Vue.i18n.translate('table.material'),
                    field: 'weld_material',
                },
                {
                    label: Vue.i18n.translate('table.total_dia_inch_available'),
                    field: 'total_dia_inch_available_total_welding_available',
                },
                {
                    label: Vue.i18n.translate('table.prefabrication_dia_inch_available'),
                    field: 'prefabrication_dia_inch_available_total_welding_available',
                },
                {
                    label: Vue.i18n.translate('table.erection_dia_inch_available'),
                    field: 'erection_dia_inch_available_total_welding_available',
                },
                {
                    label: Vue.i18n.translate('table.total_dia_inch_welded'),
                    field: 'total_dia_inch_welded_current_welding_performed',
                },
                {
                    label: Vue.i18n.translate('table.prefabrication_dia_inch_welded'),
                    field: 'prefabrication_dia_inch_welded_current_welding_performed',
                },
                {
                    label: Vue.i18n.translate('table.erection_dia_inch_welded'),
                    field: 'erection_dia_inch_welded_current_welding_performed',
                },
            ],
            //Header
            tableHeader: true,
            tableHeaderData: {
                start: 0,
                values: [
                    {
                        text: 'table.total_welding_available',
                        colspan: 3,
                        class: 'font-weight-bold'
                    },
                    {
                        text: 'table.current_welding_performed',
                        colspan: 3,
                        class: 'font-weight-bold'
                    },
                ]
            }
        }
    },
    methods: {
        onLoadTable (response) {
            //Show charts after table is loaded
            this.rowData    = response.data;
            this.showCharts = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/welding/material_analysis/material_analysis_welding.vue